<ng-container *transloco="let t">
@if (employment) {
  <div class="modal-header">

    <h2>{{ t('wizard.income.monthlyIncomeTitle') }}</h2>

    <!-- hack to fool ngbModal autofocus -->
    <input type="text" style="display:none" />

    <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" aria-label="Close"
      (click)="activeModal.dismiss('Cross click')">
      <span class="svg-icon svg-icon-2x">
        <close-x-svg-icon></close-x-svg-icon>
      </span>
    </div>

  </div>
}

<div class="modal-body px-lg-17 py-10">
  <form #incomeForm="ngForm" class="form" novalidate id="incomeForm" name="incomeForm">
    @if (employment?.incomes?.length) {
      <div class="row">
        <span class="col-6">{{ t('wizard.income.incomeTypeColumn') }}</span>
        <span class="col-5">{{ t('wizard.income.monthlyAmountColumn') }}</span>
      </div>
      @for (income of employment.incomes; track income.incomeId) {
        <div class="row mt-3">
          <div class="col-6">
            <select class="form-select form-select-solid" data-control="select2" [name]="'income_type_' + income.incomeId"
              [(ngModel)]="income.typeOfIncome" #incomeTypeValue="ngModel" [required]="true"
              [ngClass]="{'is-invalid' : incomeTypeValue && incomeTypeValue.touched && incomeTypeValue.invalid}">
              <option [ngValue]="null">{{ t('common.selectOne') }}</option>
              @for (incomeType of employmentIncomeTypes; track incomeType.value) {
                <option [ngValue]="incomeType.value">
                  {{incomeType.name}}
                </option>
              }
            </select>
          </div>
          <div class="col-6 d-flex">
            <currency-input [(ngModel)]="income.monthlyIncome" [name]="'monthly_amount_' + income.incomeId"
              [allowDecimals]="false" [min]="0" [placeholder]="t('wizard.income.monthlyAmountColumn')" (blur)="onIncomeChanged()">
            </currency-input>

            @if (deleteAttemptedForIncomeId != income.incomeId) {
              <a href="javascript:void(0);"
                class="btn btn-icon btn-bg-light btn-active-color-danger btn-sm ms-2 mt-1"
                style="min-width: 33.3281px;"
                (click)="onDeleteIncomeClicked(income)">
                <span class="svg-icon svg-icon-3">
                  <duotone-trash-svg-icon></duotone-trash-svg-icon>
                </span>
              </a>
            }
            @if (deleteAttemptedForIncomeId == income.incomeId) {
              <div class="d-flex ms-2 mt-1">
                <a href="javascript:void(0);" class="btn btn-icon btn-bg-light btn-active-color-success btn-sm me-1"
                  (click)="onDeleteConfirmed(income)">
                  <span class="svg-icon svg-icon-3">
                    <stockholm-check-svg-icon></stockholm-check-svg-icon>
                  </span>
                </a>
                <a href="javascript:void(0);" class="btn btn-icon btn-bg-light btn-active-color-danger btn-sm"
                  (click)="onDeleteAborted(income)">
                  <span class="svg-icon svg-icon-3">
                    <stockholm-close-svg-icon></stockholm-close-svg-icon>
                  </span>
                </a>
              </div>
            }
          </div>
        </div>
      }
      <div class="row mt-2">
        <span class="col-6"></span>
        <h5 class="col-6">{{ t('wizard.income.totalMonthly') }} {{(totalMonthly || 0) | currency}}</h5>
      </div>
    }
    @if (!employment?.incomes?.length) {
      <h4>{{ t('wizard.income.noIncomesAdded') }}</h4>
    }
    <div class="row mt-3">
      <div class="col-6">
        <a class="btn btn-outline btn-outline-dashed btn-outline-primary btn-active-light-primary mb-4"
          (click)="addIncomeClicked()">
          {{employment.incomes.length === 0 ? t('wizard.income.addIncome') : t('wizard.income.addAnotherIncome')}}
        </a>
      </div>
      <span class="col-6"></span>
    </div>
  </form>
</div>

<div class="modal-footer flex-center">
  <button type="button" class="btn btn-white me-3" (click)="activeModal.dismiss('Close click')">{{ t('common.cancel') }}</button>
  <button type="button" class="btn btn-primary" (click)="onOkClicked()">{{ t('common.ok') }}</button>
</div>
</ng-container>
